import React, { FC } from 'react';
import { Form, Select } from 'antd';
import styles from '../AnnotationForm.module.scss';
import { FindingTypeDetails } from '../../../AnnotationStandardForm/AnnotationStandardForm.slice';
import classNames from 'classnames';

type Props = {
  selectedFindingType: FindingTypeDetails | null;
  findingTypes: FindingTypeDetails[];
  disabled: boolean;
  onChange: (id: string) => void;
};

const FindingTypeSelect: FC<Props> = ({ selectedFindingType, findingTypes, disabled, onChange }) => {
  return (
    <Form.Item label='Add Finding type:' className={classNames(styles.addFinding)}>
      <Select
        showSearch
        placeholder='Please select'
        optionFilterProp='children'
        onChange={onChange}
        filterOption={true}
        disabled={disabled}
        value={selectedFindingType ? selectedFindingType.id : undefined}
      >
        {findingTypes
          .map(type => (
            <Select.Option value={type.id!} key={type.id} disabled={type.findingTypeTemplate?.isMLRelated}>
              {type.findingTypeTemplate?.isMLRelated ? '(ML) ' : ""}{type.findingTypeTemplate!.name}
            </Select.Option>
          ))}
      </Select>
    </Form.Item>
  );
};

export default FindingTypeSelect;
